import { __assign } from "tslib";
import { createAppCustomJsApi, appCustomJsApiRelativePath } from './index';
import { createHttpTestKit } from '../../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder } from '../../../test-utils';
export var createAppCustomJsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAppCustomJsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGet: function () {
            return createFakeGetResponder(fakeHttp, "" + appCustomJsApiRelativePath);
        },
        whenUpdate: function (dto) {
            return createFakePutResponder(fakeHttp, "" + appCustomJsApiRelativePath)(dto.data);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map